export const SubmitProductActionTypes = {
    SUBMIT_PRODUCT_REQUEST: "SUBMIT_PRODUCT_REQUEST",
    SUBMIT_PRODUCT_SUCCESS: "SUBMIT_PRODUCT_SUCCESS",
    SUBMIT_PRODUCT_FAILURE: "SUBMIT_PRODUCT_FAILURE",
    DELETE_PRODUCT_REQUEST: "DELETE_PRODUCT_REQUEST",
    DELETE_PRODUCT_SUCCESS: "DELETE_PRODUCT_SUCCESS",
    DELETE_PRODUCT_FAILURE: "DELETE_PRODUCT_FAILURE",
    UPDATE_PRODUCT_REQUEST: "UPDATE_PRODUCT_REQUEST",
    UPDATE_PRODUCT_SUCCESS: "UPDATE_PRODUCT_SUCCESS",
    UPDATE_PRODUCT_FAILURE: "UPDATE_PRODUCT_FAILURE",
};
